import services from '../services'
import * as types from './mutation-types'

export const getAll = ({ commit }, params) => (
  services.list(params).then(res => {
    commit(types.SET_TASKS, res.data)
  })
)

export const show = async ({ commit }, id) => {
  await services.show(id).then(res => {
    commit(types.SET_TASK, res.data.data)
  })
}

export const getContacts = ({ commit }, obj) => (
  services.listContacts(obj).then(res => {
    commit(types.SET_CONTACTS, res.data)
  })
)

export const save = async ({ commit }, obj) => {
  await services.save(obj).then(res => {
    commit(types.SET_TASK, res.data.data)
    return res
  })
}
